const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/modules/CIS4m/saga.ts';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { ActionSaveCIS4m, actionSaveCIS4mFailure, actionSaveCIS4mSuccess, SAVE_CIS4M } from './actions';
import { makeSelectCIS4m } from './store';

function* saveCIS4m(action: ActionSaveCIS4m): Generator<any, void> {
    const { formId } = action.payload;
    const form = yield select(makeSelectCIS4m(formId));
    if (form) {
        const success = yield call(form.callback, formId, form.dataObject.toJS());
        if (success === true) {
            yield put(actionSaveCIS4mSuccess(formId));
        } else if (success === false) {
            yield put(actionSaveCIS4mFailure(formId));
        }
    } else {
        throw Error(`There should really be a form when calling saveCIS4m: ${formId}`);
    }
}

export default function* (): Generator {
    yield takeEvery([SAVE_CIS4M], saveCIS4m);
}
